import { Box } from "@mui/material";
import React from "react";

import Logo from "components/shared/Logo";

import { useStyles } from "./styles";

const ExternalPageFooter: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.footer}>
      <Logo
        variant="mini"
        imgHeight={24}
        imgWidth={26}
        objectFit="contain"
      />
      <Box className={classes.footerDivider} />
      <a
        href="https://flowls.com"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.footerLink}
      >
        flowls.com
      </a>
    </Box>
  );
};

export default ExternalPageFooter;
